import React from 'react';

import {Icon, WithTooltip} from '@albert-io/atomic';
import type {ClassroomModelV1} from '@albert-io/models';
import systemTimeOffsetStore from 'generic/SystemTimeOffset/SystemTimeOffset.store';
import {renderMoment} from 'lib/timeUtils';

import {AUTO_ARCHIVE_DETAIL_COPY} from './autoArchiveCopy';

const TOOLTIP_PROPS = {
  placement: 'right',
  theme: 'light',
  // focusable: the archive explanation must be reachable by keyboard/AT
  focusable: true,
  tooltipClassName: 'rounded-x1! shadow-l2!'
} as const;

/** Mirrors AutoArchiveClassroomsBanner's warning window: a future date within two weeks. */
export const isAutoArchivingSoon = (classroom: ClassroomModelV1 | null): boolean => {
  const autoArchiveDate = classroom?.getAutoArchiveDate?.();
  if (!autoArchiveDate) {
    return false;
  }
  return (
    systemTimeOffsetStore.getCurrentTime().isBefore(autoArchiveDate) &&
    systemTimeOffsetStore.getCurrentTime().add(2, 'weeks').isAfter(autoArchiveDate)
  );
};

export const AutoArchiveChip = ({classroom}: {classroom: ClassroomModelV1}) => {
  // Render in UTC: auto_archive_date is a calendar date stored as UTC midnight
  const archiveDate = renderMoment(
    classroom.getAutoArchiveDate(),
    'dateFormalShortWithFullMonth',
    'UTC'
  );

  return (
    <WithTooltip
      {...TOOLTIP_PROPS}
      content={`On ${archiveDate}, Albert will automatically archive this class. ${AUTO_ARCHIVE_DETAIL_COPY}`}
    >
      {/* Raw span: no warning Chip variant exists yet */}
      <span className='inline-flex items-center gap-x0-half rounded-full border border-[color:var(--color-content-warning)] background-primary px-x1 py-x0-quarter text-s content-warning'>
        Auto-archiving on {archiveDate}
        <Icon icon='info-circle' iconStyle='regular' />
      </span>
    </WithTooltip>
  );
};
